module.exports = __webpack_public_path__ + "img/featured.5f402d7a.jpg";